module.exports = __webpack_public_path__ + "img/otopack250-active.fd809c18.svg";